module.exports = __webpack_public_path__ + "static/media/excel.c59164de.svg";